<template>
	<div id="app">
		<router-view :key="$route.path" />
		<notifications group="main" position="bottom right" />
		<modals-container />
		<v-dialog />
		<TekaChat :isVisible="!['/', '/ResultAna'].includes($route.path)" />
	</div>
</template>

<script>
import TekaChat from "@/components/src/TekaChatComponent";
export default {
	name: "App",
	components: { TekaChat },
};
</script>

<style lang="less">
@import (reference) url("./assets/variables.less");

#app {
	--primary-color: lightgoldenrodyellow;
	--secondary-color: black;
	--accent-color: blue;
	--text-color: white;
}

@primary-color: var(--primary-color);
@secondary-color: var(--secondary-color);
@accent-color: var(--accent-color);
@text-color: var(--text-color);

#app {
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
		Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
	height: 100vh;
	width: 100vw;

	/* width */
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px lightgray;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		// .sombra;
		background: dimgray;
		border-radius: 2px;
	}
}

.button-div {
	display: flex;
	justify-content: start;
	margin: 16px 0 0;
	gap: 1rem;
}

.button {
	font-weight: 500;
	padding: 12px 16px;
	font-size: 1.1rem;
	box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	border: 0;
	color: white;
	.clicavel;
	.default-hover;

	&.outline {
		color: #dc143d !important;
		background-color: white;
		border: #dc143d 1px solid;

		align-items: end;
	}

	&:disabled {
		background-color: #b0b0b0 !important;
		color: #ffffffb3 !important;
		cursor: not-allowed !important;
		box-shadow: none !important;
		opacity: 0.6;
	}
}

html,
body {
	display: block;
	height: 100%;
	width: 100%;
	margin: 0;
	padding: 0;
}

.grided-template {
	height: 100vh;
	width: 100vw;
	display: grid;
	grid-template-columns: 100px calc(100vw - 100px);

	>div {
		overflow-x: hidden;
		overflow-y: auto;
	}

	.fieldSelected {
		font-size: 0.7rem;
		border: solid 1px white;
		background: #fff;
		display: inline-block;
		// width: calc(100% - 110px);
		margin-left: 10px;
		vertical-align: middle;

		.vs__clear {
			display: none;
		}

		.vs__selected-options {
			display: block;
			// max-width: 93%;
			height: 23px;
		}

		s.vs__selected {
			color: rgba(0, 0, 0, 1) !important;
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		input {
			// display: none;
		}

		svg {
			fill: rgba(0, 0, 0, 1);
		}
	}
}

.v--modal-box.v--modal {
	/*width: 40vw!important;*/
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.v-select.vs--single.vs--searchable {
	.vs__spinner {
		width: 3.6em;
		height: 3.6em;
	}

	&.loadingData {
		.vs__spinner {
			display: block !important;
			opacity: 1;
		}

		.vs__open-indicator {
			display: none;
		}
	}
}

.confirmation-dialog-box {
	margin-bottom: 30px;

	width: auto;
	margin: auto;
	padding: 5px;

	.title {
		text-align: center;
		margin-left: 0;
		margin-top: 10px;
		font-weight: normal;
		font-size: 1rem;
		margin-block-end: 0;
	}

	.dialog-button-container {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		gap: 10px;

		.confirmation-dialog-button {
			.button;
			min-width: 150px;
		}
	}
}

//   .options-bunch-cell-editor{

//     background: red;
// }

.vs__dropdown-toggle {
	overflow: hidden;
	/* Garante que nada dentro do contêiner ultrapasse */
	white-space: nowrap;
	/* Mantém o texto em uma linha */
	text-overflow: ellipsis;
	/* Exibe "..." no final do texto que ultrapassa o tamanho */
	max-height: 35px;
	/* Define o tamanho máximo de altura */
	max-width: 100%;
	/* Garante que o dropdown-toggle ocupe toda a largura disponível */
}

.vs__dropdown-menu {
	width: fit-content(100em);
	max-width: 80vw;
	/* Limita a largura máxima ao tamanho da tela */
	max-height: fit-content;
}

// .modal-select .vs__dropdown-menu{
// 	height: clamp(9.6rem, 12dvh, 15rem) !important;
// 	max-height: clamp(9.6rem, 12dvh, 15rem) !important;
// }

.vs__dropdown-option {
	white-space: normal;
	/* Permite a quebra de linha */
	word-wrap: break-word;
	/* Quebra palavras longas */
	overflow-wrap: break-word;
	/* Quebra palavras longas */
}

.select-container .vs__selected-options {
	max-height: 8vh;
	overflow-y: auto;
	-ms-overflow-style: none;

	scrollbar-width: none; // Firefox

	// WebKit (Chrome, Safari, Edge Chromium, etc.)
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: transparent;
		border: none;
	}
}
</style>
